import { render, staticRenderFns } from "./GeneralInfoStep.vue?vue&type=template&id=ad88e2b4&scoped=true"
import script from "./GeneralInfoStep.vue?vue&type=script&lang=js"
export * from "./GeneralInfoStep.vue?vue&type=script&lang=js"
import style0 from "./GeneralInfoStep.vue?vue&type=style&index=0&id=ad88e2b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad88e2b4",
  null
  
)

export default component.exports